import { SERVICE_COLLECTION } from '../constants';
import { TYPE_COLLECTION } from './input-types';

export const id = SERVICE_COLLECTION;
export const apiKey = 'ServiceCollectionGuid';
export const type = TYPE_COLLECTION;

export const serviceCollection = {
  id,
  apiKey,
  type,
};
